export enum TicketDetails {
  'AreaLine1' = 0,
  'Stand' = 1,
  'StandName' = 2,
  'Area' = 3,
  'Hide' = 4,
}
